import { useStyletron } from 'baseui'; // eslint-disable-next-line baseui/no-deep-imports
import { mergeOverride, toObjectOverride } from 'baseui/helpers/overrides';
import { Icon, IconProps } from 'baseui/icon';
import { h } from 'preact';
import { forwardRef } from 'preact/compat';

export default forwardRef<SVGSVGElement, IconProps>((props: IconProps, ref) => {
    const [, theme] = useStyletron();
    const { title = 'Schedule', size, color, overrides = {},...restProps } = props;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    const SvgOverride = mergeOverride( // @ts-ignore
        { component: theme.icons?.Schedule ? theme.icons.Schedule : null },
        overrides?.Svg ? toObjectOverride(overrides.Svg) : {},
    );
    return (
        <Icon viewBox="0 96 960 960"
              ref={ref}
              title={title}
              size={size}
              color={color}
              overrides={{ Svg: SvgOverride }}
              {...restProps}>
            <path d="m612 764 56-56-148-148V376h-80v216l172 172ZM480 976q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Zm0-400Zm0 320q133 0 226.5-93.5T800 576q0-133-93.5-226.5T480 256q-133 0-226.5 93.5T160 576q0 133 93.5 226.5T480 896Z" />
        </Icon>
    );
});
